import { render } from "./component-ckj.vue?vue&type=template&id=33b4286a"
import script from "./component-ckj.vue?vue&type=script&lang=js"
export * from "./component-ckj.vue?vue&type=script&lang=js"

import "./component-ckj.vue?vue&type=style&index=0&id=33b4286a&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__